export { default } from '../tile';
